module.exports = __webpack_public_path__ + "static/media/yves-saint-laurent-manifesto-big.852795f5.png";